import { useState } from "react";
import { createUseStyles } from "react-jss";
import SidebarLightbox from "../../refresh/SidebarLightbox";
import GenericOptions from "../GenericOptions";
import styles from "./sharedStyles";
import MovementOptions from "../MovementOptions";

const useStyles = createUseStyles({
  ...styles,
});

const EditFadeHotspot = ({
  show,
  hotspot,
  onClose,
  onComplete,
  account,
  editing,
  images,
}) => {
  const classes = useStyles();
  const [config, setConfig] = useState(hotspot);

  return (
    <SidebarLightbox
      show={show}
      onClose={onClose}
      sidebar={
        <>
          <h1 className={classes.title}>Edit Crossfade Hotspot</h1>
          <p className={classes.subtitle}>Move with a little fade</p>
          <div className={classes.grow} />
        </>
      }
    >
      <div className={classes.options}>
        <GenericOptions
          icon="Crossfade"
          config={config}
          setConfig={setConfig}
          account={account}
          title={false}
        />
        <MovementOptions
          editing={editing}
          config={config}
          setConfig={setConfig}
          images={images}
          onComplete={onComplete}
        />
      </div>
    </SidebarLightbox>
  );
};

export default EditFadeHotspot;
